import { useEffect, useRef } from 'react';

import { parseAdUnitTargetingParams } from 'common/utils/ad-unit-targeting';

import { useGpt } from './use-gpt';

export function useGptSlot(
	id: string,
	path: string,
	sizes: googletag.GeneralSize,
	enabled: boolean,
	targeting?: string
) {
	const ready = useGpt({ enabled });
	const slotRef = useRef<googletag.Slot | null>(null);

	useEffect(() => {
		if (!ready) return undefined;

		if (!slotRef.current) {
			window.googletag.cmd.push(() => {
				slotRef.current = window.googletag.defineSlot(path, sizes, id);
				if (!slotRef.current) return;

				slotRef.current.addService(window.googletag.pubads());

				const targets = parseAdUnitTargetingParams(targeting ?? '');

				if (Array.isArray(targets)) {
					targets.forEach(target => {
						const key = target.name;
						const value = target.value.split(',').map(item => item.trim());

						if (key && value) slotRef.current?.setTargeting(key, value);
					});
				}

				window.googletag.display(id);
			});
		}

		return () => {
			if (slotRef.current) {
				window.googletag.cmd.push(() => {
					window.googletag.destroySlots([slotRef.current!]);
				});
			}
		};
	}, [ready, id, path, sizes, targeting]);

	return null;
}
